export default "__VITE_ASSET__Zi1GbOmR__"